/**
 * Normalize lead category labels to singular "Lead" wording for UI.
 * Handles API data from before DB migration 0034 (plural) and after (singular).
 */
const PLURAL_TO_SINGULAR = {
  "Cold Leads": "Cold Lead",
  "Warm Leads": "Warm Lead",
  "Marketing Leads (MQLs)": "Marketing Lead (MQL)",
  "Sales Qualified Leads (SQLs)": "Sales Qualified Lead (SQL)",
  "Product Qualified Leads (PQLs)": "Product Qualified Lead (PQL)",
  "Service Qualified Leads (SVLs)": "Service Qualified Lead (SVL)",
  "Referral Leads": "Referral Lead",
  "Inbound Leads": "Inbound Lead",
  "Outbound Leads": "Outbound Lead",
};

const DEFAULT_LABEL = "Cold Lead";

export function displayLeadCategoryLabel(label) {
  if (label == null || String(label).trim() === "") return DEFAULT_LABEL;
  const t = String(label).trim();
  if (PLURAL_TO_SINGULAR[t]) return PLURAL_TO_SINGULAR[t];
  return t;
}
